/*
 * Copyright (c) 2023-2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      19 February 2024
 */

import { Fragment } from 'react';
import { Disclosure } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Link, NavLink } from 'react-router-dom';

export const classNames = (...classes: any[]) => {
  return classes.filter(Boolean).join(' ');
};

const NavBar = () => {
  return (
    <header>
      <Disclosure as='nav' className='bg-dark-950'>
        {({ open }) => (
          <>
            <div className='mx-auto max-w-full px-2 sm:px-6 lg:px-8'>
              <div className='relative flex h-16 sm:h-20 items-center justify-between'>
                <div className='absolute inset-y-0 right-0 flex items-center sm:hidden'>
                  {/* Mobile menu button*/}
                  <Disclosure.Button className='relative inline-flex items-center justify-center rounded-md p-2 text-dark-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white'>
                    <span className='absolute -inset-0.5' />
                    <span className='sr-only'>Open main menu</span>
                    {open ? (
                      <XMarkIcon className='block h-6 w-6' aria-hidden='true' />
                    ) : (
                      <Bars3Icon className='block h-6 w-6' aria-hidden='true' />
                    )}
                  </Disclosure.Button>
                </div>
                <div className='flex flex-1 items-center justify-center sm:items-stretch justify-between'>
                  <Link to='/' className='shrink-0 flex items-center'>
                    <h1 className='font-ethnocentric text-dark-50 text-xl sm:text-2xl'>
                      ARTCUT
                    </h1>
                  </Link>
                  <div className='hidden sm:ml-6 sm:block'>
                    <div className='flex space-x-4'>
                      <NavLink
                        to='/'
                        className={({ isActive }) =>
                          classNames(
                            isActive
                              ? 'border-dark-200 hover:border-dark-50 border-b-4'
                              : 'hover:border-dark-200 hover:border-b-4',
                            'text-dark-200 px-3 py-2 text-xl hover:text-dark-50 font-poppins font-semibold'
                          )
                        }
                      >
                        PROJECTS
                      </NavLink>
                      <NavLink
                        to='/about-us'
                        className={({ isActive }) =>
                          classNames(
                            isActive
                              ? 'border-dark-200 hover:border-dark-50 border-b-4'
                              : 'hover:border-dark-200 hover:border-b-4',
                            'text-dark-200 px-3 py-2 text-xl hover:text-dark-50 font-poppins font-semibold'
                          )
                        }
                      >
                        ABOUT US
                      </NavLink>
                      <NavLink
                        to='/contact-us'
                        className={({ isActive }) =>
                          classNames(
                            isActive
                              ? 'border-dark-200 hover:border-dark-50 border-b-4'
                              : 'hover:border-dark-200 hover:border-b-4',
                            'text-dark-200 px-3 py-2 text-xl hover:text-dark-50 font-poppins font-semibold'
                          )
                        }
                      >
                        CONTACT US
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Disclosure.Panel className='sm:hidden'>
              {({ close }) => (
                <>
                  <div className='space-y-1 px-2 pb-3 pt-2 text-center'>
                    <NavLink
                      to='/'
                      className={({ isActive }) =>
                        classNames(
                          isActive
                            ? 'border-dark-200 hover:border-dark-50 border-b-4'
                            : 'hover:border-dark-200 hover:border-b-4',
                          'text-dark-200 px-3 py-2 text-xl hover:text-dark-50 font-poppins font-semibold'
                        )
                      }
                      onClick={() => close()}
                    >
                      PROJECTS
                    </NavLink>
                  </div>
                  <div className='space-y-1 px-2 pb-3 pt-2 text-center'>
                    <NavLink
                      to='/about-us'
                      className={({ isActive }) =>
                        classNames(
                          isActive
                            ? 'border-dark-200 hover:border-dark-50 border-b-4'
                            : 'hover:border-dark-200 hover:border-b-4',
                          'text-dark-200 px-3 py-2 text-xl hover:text-dark-50 font-poppins font-semibold'
                        )
                      }
                      onClick={() => close()}
                    >
                      ABOUT US
                    </NavLink>
                  </div>
                  <div className='space-y-1 px-2 pb-3 pt-2 text-center'>
                    <NavLink
                      to='/contact-us'
                      className={({ isActive }) =>
                        classNames(
                          isActive
                            ? 'border-dark-200 hover:border-dark-50 border-b-4'
                            : 'hover:border-dark-200 hover:border-b-4',
                          'text-dark-200 px-3 py-2 text-xl hover:text-dark-50 font-poppins font-semibold'
                        )
                      }
                      onClick={() => close()}
                    >
                      CONTACT US
                    </NavLink>
                  </div>
                </>
              )}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </header>
  );
};

export default NavBar;
